import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            专题合集
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            分类索引，快速找到感兴趣的内容板块
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexData.slice(0, 4).map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group flex flex-col items-center p-5 md:p-6 bg-background-100 rounded-xl border border-background-200/60 hover:border-primary-200 cursor-pointer transition-all duration-200 text-center"
            >
              <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">
                {item.title}
              </h3>
              <span className="mt-1.5 text-xs font-medium text-accent-600 bg-accent-100 px-3 py-0.5 rounded-full whitespace-nowrap">
                {item.count}
              </span>
              <p className="mt-3 text-xs md:text-sm text-foreground-600">
                {item.desc}
              </p>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {indexData.slice(4, 7).map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group flex flex-col items-center p-5 md:p-6 bg-background-100 rounded-xl border border-background-200/60 hover:border-primary-200 cursor-pointer transition-all duration-200 text-center"
            >
              <div className="w-14 h-14 rounded-2xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">
                {item.title}
              </h3>
              <span className="mt-1.5 text-xs font-medium text-accent-600 bg-accent-100 px-3 py-0.5 rounded-full whitespace-nowrap">
                {item.count}
              </span>
              <p className="mt-3 text-xs md:text-sm text-foreground-600">
                {item.desc}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}